import React from 'react';
import * as _ from 'lodash';
import assert from 'assert';
import {
  stringSortCompareAsc,
  stringSortCompareDesc,
} from '../utilities/sortUtility';

import { FieldTreeService } from '../services/FieldTrees';

import { Edited } from './modals/Commons';
import dialogLoader from '../utilities/dialogLoader';
import {
  PartnerCompaniesOrderContents,
  PrivatePartnerCompaniesOrderContents,
} from '../components/tables/PartnerCompaniesOrder';
import Helmet from 'react-helmet';
import { HEADER_CONSTANTS } from '../utilities/constants';

export class PartnerCompaniesOrder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldId: sessionStorage.getItem('field_id'),
      fieldTreeId: null,
      fieldTreeIdHistories: [],
      partnerCompanies: [],
      dragSort: [], //ドラッグアンドドロップの並び順の仮置き場
      columnSortOrder: '', // 列ソートの状態変数
    };

    this.events = {
      //ドラッグアンドドロップ用メソッド
      table: {
        setFieldTreeId: this.setFieldTreeId.bind(this),
        prevFieldTreeId: this.prevFieldTreeId.bind(this),
      },
      dnd: {
        onHover: this.onHover.bind(this),
        onBeginDrag: this.onBeginDrag.bind(this),
        onDropped: this.onDropped.bind(this),
        orderSubmit: this.eventOrderSubmit.bind(this),
      },
      columnSort: {
        onClickColumnTitle: this.onClickColumnTitle.bind(this),
      },
    };
  }

  componentDidMount() {
    this.setPartnerCompanies(this.state.fieldTreeId);
  }

  setPartnerCompanies(fieldTreeId) {
    const fieldId = this.state.fieldId;
    const param = {
      field_tree_id: fieldTreeId,
    };
    FieldTreeService.levelList(fieldId, param).then(resp => {
      if (!resp.result) {
        return;
      }
      this.setState({
        partnerCompanies: _.cloneDeep(resp.data.entities.field_trees),
      });
    });
  }

  setFieldTreeId(fieldTreeId) {
    const fieldTreeIdHistories = this.state.fieldTreeIdHistories;
    fieldTreeIdHistories.push(this.state.fieldTreeId);
    this.setPartnerCompanies(fieldTreeId);
    this.setState({
      partnerCompanies: [],
      fieldTreeId,
      fieldTreeIdHistories,
    });
  }

  prevFieldTreeId() {
    const fieldTreeIdHistories = this.state.fieldTreeIdHistories;
    const fieldTreeId = fieldTreeIdHistories.pop();
    this.setPartnerCompanies(fieldTreeId);
    this.setState({
      partnerCompanies: [],
      fieldTreeId,
      fieldTreeIdHistories,
    });
  }

  /* eslint-disable no-unused-vars */

  /**
   * ホバー
   */
  onHover(props, monitor, component) {}

  /**
   * ドラッグ開始
   */
  onBeginDrag(props, monitor, component) {
    let dragSort = _.cloneDeep(this.state.dragSort);
    dragSort[0] = props.index;
    this.setState({ dragSort });
  }

  /**
   * ドロップダウン
   */
  onDropped(dragProps, dropProps, monitor, dropComponent) {
    let dragSort = _.cloneDeep(this.state.dragSort);
    dragSort[1] = dropProps.index;
    this.setState({ dragSort });
    this.sortList(...this.state.dragSort);

    this.setState({ columnSortOrder: '' }); // 列ソート解除
  }
  /* eslint-enable no-unused-vars */

  /**
   * @description 並び順を変更する
   */
  sortList(dragId, toId) {
    const lists = _.cloneDeep(this.state.partnerCompanies);
    let dragIndex = 0;
    const formItem = _.find(lists, (item, index) => {
      dragIndex = index;
      return item.id === dragId;
    });
    const toIndex = _.findIndex(lists, { id: toId });
    if (toIndex < dragIndex) {
      lists.splice(toIndex, 0, formItem);
      lists.splice(dragIndex + 1, 1);
    } else {
      lists.splice(toIndex + 1, 0, formItem);
      lists.splice(dragIndex, 1);
    }
    this.setState({ partnerCompanies: lists });
  }

  eventOrderSubmit = () => {
    const fieldId = this.state.fieldId;
    const items = this.state.partnerCompanies;
    const params = { ids: _.map(items, 'id') };
    FieldTreeService.updateOrder(fieldId, params).then(resp => {
      if (resp.result) {
        dialogLoader.show(Edited);
        this.setPartnerCompanies(this.state.fieldTreeId);
      }
    });
  };

  /**
   * @description 一覧列ヘッダーのクリックイベント、ソート機能
   * @param {String} columnSortKey ソートするKey名
   */
  onClickColumnTitle(columnSortKey) {
    assert(
      ['partnerCompanyName', 'partnerCompanyNameKana', 'job'].includes(
        columnSortKey
      )
    );

    // ソート状態変数の更新
    let columnSortOrderValue;
    if (this.state.columnSortOrder === `${columnSortKey}_asc`) {
      columnSortOrderValue = `${columnSortKey}_desc`;
    } else {
      columnSortOrderValue = `${columnSortKey}_asc`;
    }

    // 実際のソート処理
    const lists = _.cloneDeep(this.state.partnerCompanies);

    switch (columnSortOrderValue) {
      case 'partnerCompanyName_asc':
        lists.sort((a, b) => {
          return stringSortCompareAsc(a.company_name, b.company_name);
        });
        break;
      case 'partnerCompanyName_desc':
        lists.sort((a, b) => {
          return stringSortCompareDesc(a.company_name, b.company_name);
        });
        break;
      case 'partnerCompanyNameKana_asc':
        lists.sort((a, b) => {
          return stringSortCompareAsc(a.company_kana, b.company_kana);
        });
        break;
      case 'partnerCompanyNameKana_desc':
        lists.sort((a, b) => {
          return stringSortCompareDesc(a.company_kana, b.company_kana);
        });
        break;
      case 'job_asc':
        lists.sort((a, b) => {
          return stringSortCompareAsc(a.job, b.job);
        });
        break;
      case 'job_desc':
        lists.sort((a, b) => {
          return stringSortCompareDesc(a.job, b.job);
        });
        break;
    }

    this.setState({
      columnSortOrder: columnSortOrderValue,
      partnerCompanies: lists,
    });
  }

  render() {
    return (
      <div className='setting-main__body'>
        <Helmet>
          <title>{HEADER_CONSTANTS.conference} - 協力会社並び順変更</title>
        </Helmet>
        <div id='setting-header' className='setting-header'>
          <div className='setting-header__item'>
            <button
              className='btn--effective'
              onClick={() => {
                this.events.dnd.orderSubmit();
              }}
            >
              保存する
            </button>
            {this.state.fieldTreeIdHistories.length > 0 ? (
              <button
                className='btn--sub'
                onClick={() => this.events.table.prevFieldTreeId()}
              >
                戻る
              </button>
            ) : null}
            <div className='btn-menu__item --fx-auto sm--hidden' />
          </div>
        </div>
        <PartnerCompaniesOrderContents
          partnerCompanies={this.state.partnerCompanies}
          nestCount={this.state.fieldTreeIdHistories.length}
          callbacks={this.events}
          canDrag={true}
          columnSortOrder={this.state.columnSortOrder}
        />
        <PrivatePartnerCompaniesOrderContents
          partnerCompanies={this.state.partnerCompanies}
          nestCount={this.state.fieldTreeIdHistories.length}
          callbacks={this.events}
          canDrag={true}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PartnerCompaniesOrder.jsx